export default __webpack_public_path__ + "static/media/rightArrow.aba1647c.svg";